import { useEffect, useState } from "react";
import { useApiClient } from "../../../../shared/hooks";
import { createDailyCounts } from "../utils/createDailyCounts";

function useLineOfDailyPosts(startDate: string, endDate?: string) {
  const apiClient = useApiClient();

  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);
  const [postData, setPostData] = useState<any>(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        setIsError(false);
        const data = await apiClient.getPostAnalyticsData(startDate, endDate);
        setPostData(data);
      } catch (error) {
        setIsError(true);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [startDate, endDate]);

  if (!postData) {
    return {
      data: null,
      isLoading,
      isError,
    };
  }

  const data = createDailyCounts(postData.created_at_dates, startDate, endDate);

  return {
    data,
    isLoading,
    isError,
  };
}

export default useLineOfDailyPosts;
